import React, { useEffect, useState } from 'react';
import './index.css';
import TimelineChart from './TimeLineChart/timeLineChart';
import { useDispatch, useSelector } from 'react-redux';
import { setLifeCalendarPageMenu, setLifeCalendarPagePreviousPragnancy } from '@store/actions/beneficiaryAction';
import { getBeneficiaryLifeCalenderDataApi } from '@services/LifeCalendarServices';
import { useParams } from 'react-router-dom';
import { benef_life_calendar_const } from '@constants/beneficiaryConstant';
import { handleForAborTion, handleForBenefDeath, handleForBenefRegistration, handleForDelivery, handleForFamilyPlanning, handleForOnGoingPregnancy } from '@utils/lifeCalendarUtils';
import { RootState } from '@store/reducers';
import PreviousPregnancyDetails from './PreviousPregnancyDetails';

const LineCalendarComponent: React.FC = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [timelineEvents, setTimelineEvents] = useState<any[]>([]);
    const pageForPreviousPregnancyFromLifeCalendar = useSelector(
        (state: RootState) => state?.beneficiary?.pageForPreviousPregnancyFromLifeCalendar,
    );

    const constructObject = (year: any, month: any, pageType: any, title: any, eventDate: any, subtitle: any = '', isPreviousPragnancy: any = false, pregnancyId: any = '', currentServices: any = false) => {
        return {
            year: year,
            month: month,
            pageType: pageType,
            title: title,
            subtitle: subtitle,
            pregnancyId: pregnancyId,
            currentServices: currentServices,
            eventDate: eventDate,
            isPreviousPragnancy: isPreviousPragnancy
        }
    };

    const sortAndMapEventData = (timelineEvents: any[]): any => {
        return timelineEvents.length > 0 ? timelineEvents.sort((a, b): any => {
            if (a.pageType === 'death' && b.pageType !== 'death') {
                return 1;
            }
            if (b.pageType === 'death' && a.pageType !== 'death') {
                return -1;
            }
            const bDate: any = new Date(b.eventDate);
            const aDate: any = new Date(a.eventDate);
            return aDate - bDate;
        }).map((ele: any, index: any) => {
            return {
                ...ele,
                position: (index % 2 === 0) ? 'top' : 'bottom'
            }
        }) : [];
    };

    const constructCalendarData = (calendarData: any) => {
        let timelineEvents: any[] = [];

        Object.entries(calendarData).forEach(([key, value]: any) => {
            if (key === benef_life_calendar_const.calendarDataKey.benf_reg_dt && value) {
                const objData = handleForBenefRegistration(value);
                timelineEvents.push(constructObject(objData.year, objData.month, objData.pageType, objData.title, objData.eventDate));
            } else if (key === benef_life_calendar_const.calendarDataKey.family_planning_details && value && value.length > 0) {
                value.forEach((element: any) => {
                    const objData = handleForFamilyPlanning(element);
                    timelineEvents.push(constructObject(objData.year, objData.month, objData.pageType, objData.title, objData.eventDate, objData.subtitle));
                });
            } else if (key === benef_life_calendar_const.calendarDataKey.pregnancy_details && value && value.length > 0) {
                value.forEach((element: any, index: any) => {
                    if (element.pregnancy_status_code === benef_life_calendar_const.pregnancyStatus.abortion) {
                        const objData = handleForAborTion(element);
                        const currentServices = (index === value.length - 1) ? true : false;
                        timelineEvents.push(constructObject(objData.year, objData.month, objData.pageType, objData.title, objData.eventDate, objData.subtitle, element.is_previous_pregnancy, objData.pregnancyId, currentServices));
                    } else if (element.pregnancy_status_code === benef_life_calendar_const.pregnancyStatus.success || element.pregnancy_status_code === benef_life_calendar_const.pregnancyStatus.still_birth) {
                        const objData = handleForDelivery(element);
                        const currentServices = (index === value.length - 1) ? true : false;
                        timelineEvents.push(constructObject(objData.year, objData.month, objData.pageType, objData.title, objData.eventDate, objData.subtitle, element.is_previous_pregnancy, objData.pregnancyId, currentServices));
                    } else if (element.pregnancy_status_code === benef_life_calendar_const.pregnancyStatus.on_going) {
                        const objData = handleForOnGoingPregnancy(element);
                        timelineEvents.push(constructObject(objData.year, objData.month, objData.pageType, objData.title, objData.eventDate, objData.subtitle, element.is_previous_pregnancy));
                    }
                });
            } else if (key === benef_life_calendar_const.calendarDataKey.v_death_details && value.is_dead === true && value.death_date) {
                const objData = handleForBenefDeath(value);
                timelineEvents.push(constructObject(objData.year, objData.month, objData.pageType, objData.title, objData.eventDate));
            }
        });
        timelineEvents = sortAndMapEventData(timelineEvents);
        setTimelineEvents(timelineEvents);
    };

    const getBeneficiaryLifeCalenderData = async () => {
        const res = await getBeneficiaryLifeCalenderDataApi(id);
        if (res) {
            const lifeCalenderData = res.data[0];
            constructCalendarData(lifeCalenderData);
        } else {
            setTimelineEvents([]);
        }
    };

    useEffect(() => {
        dispatch(setLifeCalendarPageMenu(null));
        dispatch(setLifeCalendarPagePreviousPragnancy(false));
        getBeneficiaryLifeCalenderData();
    }, []);

    return (
        <>
            {(!pageForPreviousPregnancyFromLifeCalendar) ? <>
                {timelineEvents && timelineEvents.length > 0 ? <div className='LifeCalenderContainer' >
                    <TimelineChart timelineEvents={timelineEvents} />
                </div> : <div>No Data found</div>}
            </> : <>
                <PreviousPregnancyDetails />
            </>}

        </>
    );
};

export default LineCalendarComponent;